import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import * as Text from 'theme/components/Text.style';

export const SectionTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px 0;
`;

export const SectionDescription = styled(Text.P1)`
  color: ${colours.neutral[500]};
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const EventCard = styled.div`
  background: ${colours.shade[0]};
  border-radius: 28px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  cursor: pointer;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px;
  }
`;

export const EventCardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
`;

export const MetaRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

export const MetaDot = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: ${colours.neutral[400]};
  flex-shrink: 0;
`;

export const EventTitle = styled(Text.P1)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${breakpoints.tablet}) {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }
`;

export const LoadMoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 10px 0;
`;
